//@flow

/**
 *
 * @param rems
 * @returns {number}
 */
export function remToPixel( rems ) {
    return ( parseFloat( rems ) * 10 );
}

/**
 *
 * @param pixels
 * @returns {number}
 */
export function pixelToRem( pixels ) {
    return ( parseFloat( pixels ) / 10 );
}

/**
 *
 * @param n
 * @returns {string}
 */
export function integerToLetter( n ) {
    return String.fromCharCode( 97 + n );
}

/**
 *
 * @param r
 * @param g
 * @param b
 * @param a
 * @returns {string}
 */
export function rgbaObjectToString( { r, g, b, a } ) {
    return `rgba(${ r },${ g },${ b },${ a })`;
}

/**
 *
 * @param rgba
 * @returns {{a: *, r: *, b: *, g: *}}
 */
export function rgbaStringToObject( rgba ) {
    if ( typeof rgba === 'string' ) {
        let regex = /[+-]?\d+(\.\d+)?/g;
        let floats = rgba.match( regex ).map( float => parseFloat( float ) );
        return {
            r: floats[ 0 ],
            g: floats[ 1 ],
            b: floats[ 2 ],
            a: floats[ 3 ]
        };
    }
}

/**
 *
 * @param orig
 * @returns {string}
 */
export function rgbaToHex( orig ) {
    let a,
        rgb = orig.replace( /\s/g, '' ).match( /^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i ),
        alpha = ( rgb && rgb[ 4 ] || '' ).trim(),
        hex = rgb ?
            ( rgb[ 1 ] | 1 << 8 ).toString( 16 ).slice( 1 ) +
            ( rgb[ 2 ] | 1 << 8 ).toString( 16 ).slice( 1 ) +
            ( rgb[ 3 ] | 1 << 8 ).toString( 16 ).slice( 1 ) : orig;

    if ( alpha !== '' ) {
        a = alpha;
    } else {
        a = '01';
    }

    a = ( ( a * 255 ) | 1 << 8 ).toString( 16 ).slice( 1 );
    hex = hex + a;

    return `#${ hex }`;
}

/**
 *
 * @param number
 * @returns {string|*}
 */
export const roundUpNumber = ( number ) => {
    if ( number > 1000 ) {
        const kValue = Math.round( ( ( number / 1000 ) * 100 ) / 100 );
        return kValue + 'K';
    } else if ( number > 1000000 ) {
        const kValue = Math.round( ( ( number / 1000000 ) * 100 ) / 100 );
        return kValue + 'M';
    } else return number;
};

/**
 *
 * @param number
 * @returns {string|*}
 */
export const getLetterCodeByNumber = ( number ) => {
    const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const LENGTH = ALPHABET.length;
    const repeats = Math.floor( number / LENGTH );

    if ( number < LENGTH ) {
        return ALPHABET[ number ];
    } else if ( number <= LENGTH * LENGTH ) {
        return ALPHABET[ repeats - 1 ] + '' + ALPHABET[ number - LENGTH * repeats ];
    } else {
        number === '+' ? '' : console.error( number + ' is unrecognized by getLetterCodeByNumber function' );
        return number;
    }
};